import buildApplicantStore from 'policies/applicant/store';
import ThemeProvider from 'providers/ThemeProvider';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';

const Applicant = React.lazy(() => import('policies/applicant/'));
const SpeakUp = React.lazy(() => import('policies/speak-up/'));

const applicantStore = buildApplicantStore();
const Router = () => {
  return (
    <ThemeProvider>
      <Switch>
        <Route exact path="/speak-up">
          <Redirect to="/speak-up/en" />
        </Route>

        <Route exact path="/speak-up/:lang">
          <Helmet>
            <title>Policy Hub - Speak Up</title>
          </Helmet>
          <SpeakUp />
        </Route>

        <Route path="/applicant">
          <Helmet>
            <title>Policy Hub - Applicant</title>
          </Helmet>
          <Provider store={applicantStore}>
            <Applicant />
          </Provider>
        </Route>

        <Route path="*">
          <Redirect to="/applicant" />
        </Route>
      </Switch>
    </ThemeProvider>
  );
};

export default Router;
